import React from "react";
import {
	Box,
	Grid,
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {
	CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import moment from "moment";
import getTrans from "../../../../../languages/getTrans";
import rateConvert from "../../../../../utils/rateConvert";

const ItemCard = ({item}) => {
	const classes = useStyles();
	const _mainName = () => {
		if (item?.service?.name) {
			return item?.service?.name
		}
	};
	const _mainAmount = () => {
		return rateConvert((item.amount || 0), {
			useSybmol: true,
			decimalCount: 'auto'
		})
	};

	return (
		<div className={classes.card}>
			<div className={classes.cardMain}>
				<div className={classes.cardName}>{_mainName()}</div>
				<div className={classes.cardCaption}>{moment(item.created_at).format('DD.MM.YYYY / HH:mm:ss')}</div>
				<div className={classes.cardAmount}>{_mainAmount()}</div>
			</div>
			<div className={classes.cardStatus}>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="12" cy="12" r="12" fill="#157C15"/>
					<path d="M6.5 13L10 16.5L18 8.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
			</div>
		</div>
	)
}

const useStyles = makeStyles((theme) => ({
	card: {
		display: "flex",
		padding: "8px 12px",
		borderRadius: "8px",
		background: "#FFFFFF0D",
		boxSizing: "border-box",
		border: "1px solid #FFFFFF1A",
	},
	cardMain: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
	},
	cardName: {
		fontSize: 16,
		color: "white",
		fontWeight: "500",
		lineHeight: "20px",
	},
	cardCaption: {
		fontSize: 14,
		color: "white",
		opacity: "0.5",
		lineHeight: "16px"
	},
	cardStatus: {
		width: "24px",
	},
	cardAmount: {
		marginTop: "4px",
		fontSize: 20,
		color: "white",
		fontWeight: "500",
		lineHeight: "24px",
	},
}))

export default ItemCard
